/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Property } from 'csstype';

const COLORS: Record<string, Property.Color> = {
  Background: '#096ba8',
  HeaderStepBorder: '#98a7bf',
  SectionBorderColor: '#d9d9d9',
  DividerColor: '#eaecf0',
  DividerBlueColor: '#72b7e4',
  GreyDashboardColor: '#f5f6fa',
  GreenCardColor: '#8eff8e79',
  LightBlueCardColor: '#85c2ff7c',
  RedCardColor: '#ff6e6e50',
  PurpleCardColor: '#ee37ff50',
  BlueListColor: '#2081e2',
  RedListColor: '#9e0000',
  PurpleListColor: '#7a007a',
  GreenListColor: '#00bb64',
};

export default COLORS;
